import {
  GetIframeDocument,
  GetIframeQuery,
  GetIframeQueryVariables,
  Scalars,
} from 'generated/graphql';
import { client } from './client';

export async function getIframe(id: string) {
  return client.query<GetIframeQuery, GetIframeQueryVariables>({
    query: GetIframeDocument,
    variables: {
      where: {
        id,
      },
    },
  });
}
